import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import {
  Container as ContainerBase,
  ContentWithPaddingXl,
} from "components/misc/Layouts";
import { SectionDescription } from "components/misc/Typography";
import { ReactComponent as celebrate } from "images/celebration-icon.svg";

const Container = tw(
  ContainerBase,
)`tw-my-8 lg:tw-my-10 tw-bg-primary-900 tw-text-gray-100 -tw-mx-8 tw-px-8`;
const HeadingContainer = tw.div``;
const Heading = tw(
  SectionHeading,
)`sm:tw-text-3xl md:tw-text-4xl lg:tw-text-5xl`;
const Subheading = tw(SubheadingBase)`tw-text-gray-100 tw-text-center`;
const Description = tw(
  SectionDescription,
)`tw-text-gray-400 tw-text-center tw-mx-auto tw-max-w-screen-md`;

const RacesContainer = tw.div`tw-mt-8 tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-center tw-flex-wrap tw-max-w-screen-md tw-justify-between tw-mx-auto`;
const SearchIcon = tw(celebrate)`tw-mx-auto`;

export default ({
  subheading = "COMING SOON",
  heading = "Live Leaderboard",
  description = "Want to know who's winning? Check back here soon and you'll be able to find out!",
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          <Heading>{heading}</Heading>
          {description && <Description>{description}</Description>}
        </HeadingContainer>
        <RacesContainer>
          <SearchIcon />
        </RacesContainer>
      </ContentWithPaddingXl>
    </Container>
  );
};
